import type { CreateRegistrationBody } from '@/data/courses/registration/interfaces';
import type { RegistrationFormData } from '@/packages/courses/components/user-data-form/schema';
import { extractNumbers } from '@/utils/extract-numbers';

export const buildRegistrationPayload = (
  data: RegistrationFormData,
  coupon?: string
): CreateRegistrationBody => {
  const [day, month, year] = data.birthDate.split('/');
  const birthDateISO = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

  return {
    nome: data.name,
    cpf: extractNumbers(data.cpf),
    birth_date: birthDateISO,
    country_code: data.countryCode,
    telefone: extractNumbers(data.phone),
    email: data.email,
    full_address: {
      postal_code: extractNumbers(data.cep),
      city: data.city,
      state: data.state,
      street: data.street,
      neighborhood: data.neighborhood,
      number: data.number,
      complement: data.complement || '',
    },
    address: `${data.street} ${data.number}${
      data.complement ? ` - ${data.complement}` : ''
    }, ${data.neighborhood}, ${data.cep} - ${data.city}, ${data.state}`,
    cupom: coupon || '',
  };
};
